import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "retry-form" }
const _hoisted_2 = { class: "form__header" }
const _hoisted_3 = { class: "buttons" }

import IconArrowLeft from '@/assets/VueIcons/IconArrowLeft.vue';
import IconArrowRight from '@/assets/VueIcons/IconArrowRight.vue';
import IconComponent from '@/components/IconComponent.vue';
import { inRetryForm, remainingTime } from '@/stores/gameStore';
import { useUserStore } from '@/stores/userStore';

import {
  playNextLevel,
  replayRoundWithSameImage
} from '@/utils/roundEndHelper';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RetryForm',
  setup(__props) {

const userStore = useUserStore();

const survived = userStore.currentRound.survived;

const buttonText = computed(() => {
  return survived ? "Awesome, let's move on" : "Yes, let's try again";
});

const headerText = computed(() => {
  return survived
    ? "You're ready for the next round!"
    : `Ohhhh noo...
    I know you've got what it takes. Now's your chance to shine!`;
});

function handleNextRoundOrReplay() {
  inRetryForm.value = true;
  if (survived) {
    playNextLevel();
    remainingTime.value = 60;
  } else {
    replayRoundWithSameImage();
    setTimeout(() => {
      remainingTime.value = 60;
    }, 3000);
  }
}
inRetryForm.value = false;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(headerText.value), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        onClick: handleNextRoundOrReplay,
        class: "primary-button"
      }, [
        _withDirectives(_createVNode(IconComponent, null, {
          default: _withCtx(() => [
            _createVNode(IconArrowLeft)
          ]),
          _: 1
        }, 512), [
          [_vShow, !_unref(survived)]
        ]),
        _createTextVNode(" " + _toDisplayString(buttonText.value) + " ", 1),
        _withDirectives(_createVNode(IconComponent, null, {
          default: _withCtx(() => [
            _createVNode(IconArrowRight)
          ]),
          _: 1
        }, 512), [
          [_vShow, _unref(survived)]
        ])
      ])
    ])
  ]))
}
}

})